(function () {
  if (window.__zlQuiz) return;
  window.__zlQuiz = true;

  function init() {
    var dlg = document.querySelector('[data-zl-quiz]');
    if (!dlg) return;
    var textEl = document.querySelector('[data-zl-quiz-text]');
    var T = {};
    try { T = JSON.parse(textEl ? textEl.textContent : '{}'); } catch (e) {}

    var id = dlg.id;
    var steps = ['who', 'needs', 'safety'];
    var order = ['intro'].concat(steps, ['result']);
    var state, current;
    var $ = function (s, r) { return (r || dlg).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || dlg).querySelectorAll(s)); };

    function reset() {
      state = { who: null, needs: [], flags: [] };
      $$('.zl-quiz__opt').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.hidden = false; b.removeAttribute('aria-disabled'); });
      $$('[data-quiz-next]').forEach(function (b) { b.disabled = true; });
      var msg = $('[data-signup-msg]'); if (msg) msg.textContent = '';
      show('intro');
    }

    function show(name) {
      current = name;
      $$('.zl-quiz__screen').forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== name; });
      var i = steps.indexOf(name);
      var prog = $('[data-quiz-progress]');
      prog.hidden = i < 0;
      if (i >= 0) {
        $('[data-quiz-steptext]').textContent = (T.step || 'Question {n} of {total}').replace('{n}', i + 1).replace('{total}', steps.length);
        $('[data-quiz-bar]').style.width = ((i + 1) / steps.length * 100) + '%';
      }
      $('[data-quiz-back]').hidden = name === 'intro';
      dlg.querySelector('.zl-quiz__panel').scrollTop = 0;
      var focusTarget = name === 'result' ? $('[data-result-title]') : $('[data-screen="' + name + '"] .zl-quiz__q, [data-screen="' + name + '"] .zl-btn');
      if (focusTarget && name !== 'intro') { if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus({ preventScroll: true }); }
    }

    function open() {
      reset();
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      document.documentElement.classList.add('zl-quiz-open');
      publish('zl_quiz_opened', {});
    }

    function close() {
      if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    }

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('zl-quiz-open');
      if (location.hash === '#' + id && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    });

    function publish(name, data) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    }

    function applyWho() {
      var man = state.who === 'male';
      $$('[data-women-only="true"]').forEach(function (b) {
        b.hidden = man;
        if (man && b.getAttribute('aria-pressed') === 'true') {
          b.setAttribute('aria-pressed', 'false');
          var n = b.getAttribute('data-need'), f = b.getAttribute('data-flag');
          if (n) state.needs = state.needs.filter(function (x) { return x !== n; });
          if (f) state.flags = state.flags.filter(function (x) { return x !== f; });
        }
      });
      syncNeeds(); syncFlags();
    }

    function syncNeeds() {
      var full = state.needs.length >= 2;
      $$('[data-need]').forEach(function (b) {
        var on = state.needs.indexOf(b.getAttribute('data-need')) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (full && !on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
      $('[data-quiz-next="needs"]').disabled = state.needs.length === 0;
    }

    function syncFlags() {
      $$('[data-flag]').forEach(function (b) { b.setAttribute('aria-pressed', state.flags.indexOf(b.getAttribute('data-flag')) > -1 ? 'true' : 'false'); });
      $('[data-quiz-next="safety"]').disabled = state.flags.length === 0;
    }

    function joinList(arr) {
      if (arr.length < 2) return arr.join('');
      try { return new Intl.ListFormat(document.documentElement.lang || 'en', { type: 'conjunction' }).format(arr); } catch (e) {}
      return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
    }

    function showResult() {
      var cardsWrap = $('[data-result-cards]');
      var cards = state.needs.map(function (h) { return $('[data-result="' + h + '"]'); }).filter(Boolean);
      $$('[data-result]').forEach(function (c) { c.hidden = true; });
      cards.forEach(function (c) { c.hidden = false; cardsWrap.appendChild(c); });
      var names = cards.map(function (c) { return c.getAttribute('data-name'); });
      var title = names.length > 1 ? (T.titleTwo || '{a} + {b}').replace('{a}', names[0]).replace('{b}', names[1]) : (T.titleOne || '{a}').replace('{a}', names[0]);
      $('[data-result-title]').textContent = title;
      $('[data-result-doctor]').hidden = !state.flags.some(function (f) { return f !== 'none'; });
      var overlapEl = $('[data-result-overlap]');
      overlapEl.hidden = true;
      if (cards.length === 2) {
        var split = function (c) { return (c.getAttribute('data-mushrooms') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); };
        var a = split(cards[0]), b = split(cards[1]);
        var shared = a.filter(function (x) { return b.indexOf(x) > -1; });
        if (shared.length) {
          if (!overlapEl.dataset.tpl) overlapEl.dataset.tpl = overlapEl.textContent;
          overlapEl.textContent = overlapEl.dataset.tpl.replace('{x}', joinList(shared));
          overlapEl.hidden = false;
        }
      }
      show('result');
      publish('zl_quiz_completed', { formulas: state.needs, who: state.who, flagged: !$('[data-result-doctor]').hidden });
    }

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg) { close(); return; }
      var btn = t.closest('button, a');
      if (!btn || !dlg.contains(btn)) return;

      if (btn.hasAttribute('data-quiz-close')) { close(); return; }
      if (btn.hasAttribute('data-quiz-start')) { show('who'); return; }
      if (btn.hasAttribute('data-quiz-restart')) { reset(); show('who'); return; }
      if (btn.hasAttribute('data-quiz-back')) { var i = order.indexOf(current); if (i > 0) show(order[i - 1]); return; }

      if (btn.hasAttribute('data-who')) {
        state.who = btn.getAttribute('data-who');
        $$('[data-who]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        applyWho();
        setTimeout(function () { show('needs'); }, 220);
        return;
      }
      if (btn.hasAttribute('data-need')) {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var n = btn.getAttribute('data-need');
        var at = state.needs.indexOf(n);
        if (at > -1) state.needs.splice(at, 1); else if (state.needs.length < 2) state.needs.push(n);
        syncNeeds();
        return;
      }
      if (btn.hasAttribute('data-flag')) {
        var f = btn.getAttribute('data-flag');
        var j = state.flags.indexOf(f);
        if (j > -1) state.flags.splice(j, 1);
        else if (f === 'none') state.flags = ['none'];
        else { state.flags = state.flags.filter(function (x) { return x !== 'none'; }); state.flags.push(f); }
        syncFlags();
        return;
      }
      var next = btn.getAttribute('data-quiz-next');
      if (next === 'needs' && state.needs.length) { show('safety'); return; }
      if (next === 'safety' && state.flags.length) { showResult(); return; }
    });

    // Add to cart from a result: close the quiz so the cart drawer is visible.
    dlg.addEventListener('submit', function (e) {
      if (e.target.closest('.zl-quiz__card')) setTimeout(close, 0);
    }, true);

    // Optional Klaviyo signup (client subscriptions API, public key only).
    var form = $('[data-quiz-signup]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var msg = form.querySelector('[data-signup-msg]');
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = T.signupInvalid || ''; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
        input.removeAttribute('aria-invalid');
        var names = state.needs.map(function (h) { var c = $('[data-result="' + h + '"]'); return c ? c.getAttribute('data-name') : h; });
        var btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(dlg.getAttribute('data-klaviyo-company')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Find your formula quiz',
                profile: { data: { type: 'profile', attributes: { email: email, properties: { quiz_result: names.join(', '), quiz_for: state.who } } } }
              },
              relationships: { list: { data: { type: 'list', id: dlg.getAttribute('data-klaviyo-list') } } }
            }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          msg.textContent = T.signupOk || '';
          form.querySelector('.zl-news__form').hidden = true;
          publish('zl_quiz_signup', { formulas: state.needs });
        }).catch(function () {
          msg.textContent = T.signupErr || '';
          btn.disabled = false;
        });
      });
    }

    // Openers: any link to #<id>, plus the hash on load.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hashAt = href.indexOf('#');
      if (hashAt < 0 || href.slice(hashAt + 1) !== id) return;
      var path = href.slice(0, hashAt);
      if (path && path !== location.pathname && path !== location.href.split('#')[0]) return;
      e.preventDefault();
      open();
    });
    if (location.hash === '#' + id) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
